import React, { useState } from "react";

import { useGetAggregators, useGetSenders } from "api/api-hooks/alert-fan-hooks";
import AggregatorsAndSendersCRUD from "./AggregatorsAndSendersCRUD";

const DevSandbox = () => {
  const [checked, setChecked] = useState<boolean>(false);

  const {
    data: aggregatorsData,
    error: aggregatorsError,
    isLoading: aggregatorsIsLoading,
  } = useGetAggregators({
    enabled: !checked,
  });

  const {
    data: sendersData,
    error: sendersError,
    isLoading: sendersIsLoading,
  } = useGetSenders({
    enabled: checked,
  });

  return (
    <div>
      {aggregatorsIsLoading || sendersIsLoading ? <div>Loading...</div> : null}

      {aggregatorsError || sendersError ? <div>Error loading data</div> : null}

      {!aggregatorsIsLoading &&
      !sendersIsLoading &&
      !aggregatorsError &&
      !sendersError &&
      aggregatorsData 
      ? (
        <AggregatorsAndSendersCRUD
          aggregators={aggregatorsData}
          senders={sendersData}
          checked={checked}
          setChecked={setChecked}
        />
      ) : null}
    </div>
  );
};

export default DevSandbox;
